import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import CharacterSheetExpansionFeatures from './CharacterSheetExpansionFeatures.vue';
import CharacterSheetProficienciesLanguages from './CharacterSheetProficienciesLanguages.vue';
import CharacterSheetProficienciesList from './CharacterSheetProficienciesList.vue';
let CharacterSheetProficiencies = class CharacterSheetProficiencies extends Vue {
};
__decorate([
    Prop(Array)
], CharacterSheetProficiencies.prototype, "nonCombatFeatures", void 0);
__decorate([
    Prop(Object)
], CharacterSheetProficiencies.prototype, "backgroundFeature", void 0);
__decorate([
    Prop(Array)
], CharacterSheetProficiencies.prototype, "customLanguages", void 0);
__decorate([
    Prop(Array)
], CharacterSheetProficiencies.prototype, "languages", void 0);
__decorate([
    Prop(Array)
], CharacterSheetProficiencies.prototype, "proficiencies", void 0);
__decorate([
    Prop(Array)
], CharacterSheetProficiencies.prototype, "skillAndSaveProficiencies", void 0);
__decorate([
    Prop(Array)
], CharacterSheetProficiencies.prototype, "customProficiencies", void 0);
CharacterSheetProficiencies = __decorate([
    Component({
        components: {
            CharacterSheetExpansionFeatures,
            CharacterSheetProficienciesLanguages,
            CharacterSheetProficienciesList
        }
    })
], CharacterSheetProficiencies);
export default CharacterSheetProficiencies;
